export function getUser() {
  const session = JSON.parse(localStorage.getItem("session"));
  // Retornar toda la sesión ya que ahora está aplanada
  return session;
}

export function logout(reload = true) {
  localStorage.removeItem("session");
  if (reload) window.location.reload();
}
